angular.module("app").factory("userStorage", [
    'preLoadedData',
    function (preLoadedData) {
        var info = {
            userData: {}
        };
        if (!!preLoadedData.data) {
            preLoadedData.data.userInfo && setUserData(preLoadedData.data.userInfo);
        }
        function  setUserData (userData) {
            var data = angular.copy(userData);
            for (var prop in data) {
                info.userData[prop] = angular.copy(data[prop])
            }

            !!userData && (info.authenticated = true);
        }
        return {
            setUserData: setUserData,
            resetUserData: function (userData) {
                //hard reset due to reverence
                for (var prop in info.userData) {
                    info.userData[prop] = undefined
                }
                info.authenticated = undefined;
                !!userData && setUserData(userData)
            },
            getUserData: function () {
                return info.userData
            },
            isAuthenticated: function () {
                return !!info.authenticated
            }
        }
    }
]);